import { forward as toMgrs } from 'mgrs';
import { OpenLocationCode } from 'open-location-code';

const olc = new OpenLocationCode();

export function formatCoordinate(lat, lng, format = 'decimal') {
  if (lat == null || lng == null) return '\u2014';
  switch (format) {
    case 'dms':
      return `${toDMS(lat, 'lat')}, ${toDMS(lng, 'lng')}`;
    case 'mgrs':
      try { return toMgrs([lng, lat], 5); } catch { return `${lat.toFixed(4)}, ${lng.toFixed(4)}`; }
    case 'pluscode':
      try { return olc.encode(lat, lng, 10); } catch { return `${lat.toFixed(4)}, ${lng.toFixed(4)}`; }
    case 'decimal':
    default:
      return `${lat.toFixed(4)}, ${lng.toFixed(4)}`;
  }
}

function toDMS(value, type) {
  const abs = Math.abs(value);
  const deg = Math.floor(abs);
  const minFloat = (abs - deg) * 60;
  const min = Math.floor(minFloat);
  const sec = ((minFloat - min) * 60).toFixed(1);
  const dir = type === 'lat' ? (value >= 0 ? 'N' : 'S') : (value >= 0 ? 'E' : 'W');
  return `${deg}\u00b0${String(min).padStart(2, '0')}'${sec}"${dir}`;
}

export const COORDINATE_FORMATS = [
  { value: 'decimal', label: 'coordinates.decimal' },
  { value: 'dms', label: 'coordinates.dms' },
  { value: 'mgrs', label: 'coordinates.mgrs' },
  { value: 'pluscode', label: 'coordinates.plusCode' },
];
